<script>
  import { Section, Rectangle, Label } from '@snlab/florence'
  import { scaleLinear } from 'd3-scale'

  export let height
  export let width
  export let colorScale
  export let type
  export let title
  export let leftLabel = 'Less Attention'
  export let rightLabel = 'More Attention'

  const baseOffset = 10
  const gutter = 2
  const itemWidth = 98
  let scaleItems = colorScale.domain().slice(0, -1)
  if ((title === undefined) & (type === 'count')) {
    title = 'Count (absolute intensity)'
  }
  if ((title === undefined) & (type !== 'count')) {
    title = 'Odds Ratio (relative intensity)'
  }

  $: scaleItems = colorScale.domain().slice(0, -1)
  $: {
    if (type !== 'orComparison') {
      scaleItems[scaleItems.length - 1] =
        scaleItems[scaleItems.length - 1] + '+'
    }
    if (type === 'count') {
      title = 'Count (absolute intensity)'
    }
    if (type === 'orRandom') {
      title = 'Odds Ratio (relative intensity)'
    }
  }
</script>

<Section
  x1={width / 1.9}
  x2={width / 1.9 + width / 3}
  y1={height - height / 6}
  y2={height}
  flipY
  scaleX={scaleLinear().domain([0, 500])}
  scaleY={scaleLinear().domain([0, 100])}>
  <Label
    x={0 + baseOffset}
    y={100}
    anchorPoint="lt"
    text={title}
    fontSize="14"
    fontWeight="600" />
  {#each scaleItems as step, index}
    <Rectangle
      x1={baseOffset + index * itemWidth + gutter * index}
      x2={baseOffset + (index + 1) * itemWidth + gutter * index}
      y1={20}
      y2={45}
      fill={colorScale.range()[index]} />
    <Label
      x={index * itemWidth + gutter * index}
      y={50}
      anchorPoint="lb"
      text={step}
      fontSize="12" />
  {/each}
  <Label
    x={baseOffset}
    y={0}
    anchorPoint="lb"
    text={leftLabel}
    fontSize="12"
    fontWeight="200" />
  <Label
    x={500}
    y={0}
    anchorPoint="rb"
    text={rightLabel}
    fontSize="12"
    fontWeight="200" />
</Section>
